module.exports = __webpack_public_path__ + "img/g5.9a806bc1.jpg";